import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

export class NoReuseStrategy implements RouteReuseStrategy {
	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void { }

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return null;
	}

	shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
		return false;  // Disables reuse, forcing reload
	}
}
